import { Input } from "antd";
import { SearchOutlined } from "@ant-design/icons";

interface SearchInputProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  className?: string;
  testId?: string;
}

export default function SearchInput({
  value,
  onChange,
  placeholder = "Search...",
  className = "",
  testId,
}: SearchInputProps) {
  return (
    <div data-testid={testId}>
      <Input
        prefix={<SearchOutlined className="text-gray-400" />}
        placeholder={placeholder}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className={`text-sm rounded-sm bg-[#00000005] ${className}`}
        allowClear
      />
    </div>
  );
}
